import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: 'oklch(var(--secondary-100))' }}>
      <div className="section-container py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-foreground-950">
              VigorBuy Guide
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your comprehensive resource for VigorBuy Spreadsheet reviews, comparisons, templates, and expert buying guides. Helping you make informed decisions about spreadsheet tools.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-foreground-950">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Home
              </Link>
              <Link to="/shopping-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Shopping Guide
              </Link>
              <Link to="/vigorbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Complete Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                VigorBuy Spreadsheet
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-foreground-950">
              Topics
            </h4>
            <div className="flex flex-col gap-2">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Shoes Collection
              </a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Hoodies &amp; Sweaters
              </a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                T-Shirts
              </a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Jackets
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4 text-foreground-950">
              Resources
            </h4>
            <div className="flex flex-col gap-2">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                Official Website
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="btn-primary text-xs px-4 py-2 rounded-md w-fit mt-2">
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderTop: '1px solid oklch(var(--secondary-300) / 0.5)' }}>
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} VigorBuy Guide. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Terms
            </a>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}